<template>
  <div
    id="js_header_city"
    class="header-city"
  >
    <div
      class="header-city__hd"
      @click.stop
    >
      <el-row>
        <el-col
          v-for="tab of tabs"
          :key="tab"
          :span="3"
        >
          <span
            class="header-city__tab"
            :class="curTab === tab ? 'header-city__tab_active' : ''"
            @click.stop="curTab = tab"
          >{{ tab }}</span>
        </el-col>
      </el-row>
      <!-- <a
        href="javascript:;"
        class="header-city__close"
        title="关闭弹层"
        @click.stop="hideCityLayer"
      >
        <img src="./imgs/close.png" alt="关闭弹层" />
      </a>-->
    </div>
    <div class="header-city__bd">
      <dl
        v-for="cities of getSelectedCityData"
        :key="cities[0]"
        class="header-city__item"
      >
        <dt
          v-if="cities[0] !==TLang('热门', 'my')"
          class="header-city__label"
        >
          {{ cities[0] }}
        </dt>
        <dd class="header-city__conts">
          <el-row>
            <el-col
              v-for="city of cities[1]"
              :key="city.cityId"
              class="header-city_wrap"
              :span="3"
            >
              <a
                href="javascript:;"
                :title="city.name"
                @click.stop="changeCity(city)"
              >{{ CookiesOne && CookiesOne == 'en-US' ? city.pinyin || city.name : city.name }}</a>
            </el-col>
          </el-row>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  props: {
    hotCities: {
      type: Array,
      default: () => [],
    },
    allCities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tabs: [this.TLang('热门', 'my'), 'A-D', 'E-H', 'J-M', 'N-S', 'T-X', 'Y-Z'],
      curTab: this.TLang('热门', 'my'),
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  computed: {
    getSelectedCityData() {
      let arr = [];
      const cities = Object.entries(
        this.sortCities(this.hotCities, this.allCities),
      );
      const index = this.tabs.indexOf(this.curTab);
      const hot = cities.slice(0, 1);
      const a2d = cities.slice(1, 5);
      const e2h = cities.slice(5, 9);
      const j2m = cities.slice(9, 13);
      const n2s = cities.slice(13, 18);
      const t2x = cities.slice(18, 21);
      const y2z = cities.slice(21);

      arr = [hot, a2d, e2h, j2m, n2s, t2x, y2z];

      return arr[index];
    },
  },
  created() {},
  methods: {
    sortCities(hotCities, allCities) {
      const obj = {};
      const HOT = this.TLang('热门', 'my');

      obj[HOT] = hotCities;

      allCities.forEach(city => {
        const key = city.first.toLocaleUpperCase();

        if (!obj[key]) {
          obj[key] = [];
        }

        obj[key].push(city);
      });

      return obj;
    },
    hideCityLayer() {
      this.$emit('hideCityLayer');
    },
    changeCity(cid) {
      this.$emit('cityChange', cid);
      // const { path, query } = this.$route;
      // const { city } = query;
      // // 一点小优化
      // if (cid === Number(city)) {
      //   return false;
      // }

      // this.$router.replace({
      //   path,
      //   query: {
      //     ...query,
      //     city: cid
      //   }
      // });

      //window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.header-city {
  top: 40px;
  left: 20px;
  z-index: 5;
  width: 100%;
  background-color: #fff;
  border: 0px solid #c9c9c9;
  font-size: 14px;
  &__hd {
    position: relative;
    height: 50px;
    line-height: 50px;
    background-color: #fafafa;
    border-bottom: 1px solid #d2d3d5;
    padding-left: 15px;
    padding-right: 15px;
    cursor: pointer;
  }
  &__tab {
    &_active {
      color: #0b49b7;
    }
  }
  &__close {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding-left: 10px;
    padding-right: 10px;
    > img {
      position: relative;
      width: 20px;
      vertical-align: middle;
      transition: all 0.3s ease-in-out;
    }
    &:hover > img {
      transform: rotate(180deg);
    }
  }
  &__bd {
    padding-left: 15px;
    padding-right: 15px;
    a {
      color: #828282;
      &:hover {
        color: #619ee0;
      }
    }
  }
  &__label {
    float: left;
    width: 40px;
    padding-top: 5px;
    padding-left: 8px;
    line-height: 32px;
  }
  &__conts {
    overflow: hidden;
    .header-city_wrap {
      height: 32px;
      line-height: 32px;
    }
    a {
      display: inline-block;
      width: 100%;
      padding-top: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
    }
  }
  &__item {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
